(function () {
  'use strict';

  angular
    .module('app.cart.confirmation', [])

    .directive('cartConfirmation', function () {
      return {
        restrict: 'A',
        controllerAs: 'cartCtrl',
        /* @ngInject */
        controller: ["$rootScope", function ($rootScope) {
          var ctrl = this;

          ctrl.$onInit = function () {
            $rootScope.$broadcast('userUpdate');
          };

        }]
      };
    });

})();
